module.exports = __webpack_public_path__ + "img/recruit-banner.5a62db9d.png";